// Global jungle background using the user-provided reference image
export const BG_IMAGE_URL =
  "https://customer-assets.emergentagent.com/job_64e8b197-6968-4e35-8203-b60f53bac259/artifacts/yffyz1eq_Max_a_fais_moi_une_image_s.png";

export default function JungleBackground() {
  return (
    <div
      aria-hidden="true"
      data-testid="jungle-background"
      className="fixed inset-0 -z-10 overflow-hidden bg-emerald-950"
    >
      <div
        className="absolute inset-0 bg-cover bg-center opacity-90"
        style={{ backgroundImage: `url("${BG_IMAGE_URL}")` }}
      />
      {/* dark green overlay to give consistent contrast for content */}
      <div className="absolute inset-0 bg-emerald-950/55" />
      {/* subtle radial vignette */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_transparent_30%,_rgba(2,20,12,0.7)_100%)]" />
      {/* grain */}
      <div className="absolute inset-0 opacity-[0.06] mix-blend-overlay" style={{
        backgroundImage:
          'url("data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 width=%22240%22 height=%22240%22><filter id=%22n%22><feTurbulence type=%22fractalNoise%22 baseFrequency=%220.9%22 numOctaves=%222%22/></filter><rect width=%22240%22 height=%22240%22 filter=%22url(%23n)%22 opacity=%220.6%22/></svg>")',
      }} />
    </div>
  );
}
